import React from 'react';
import { evangelismMyths, firstSteps, productName } from '../data/content';
import { CtaButton } from './CtaButton';
import { HeartMark } from './decor/HeartMark';
export function ShynessObjection() {
  return <section aria-labelledby="shy-title" className="bg-cream" data-id="element-295" data-mp="24rgc70net8r">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-296" data-mp="3tc3xwn5g18p7">
        <div className="grid gap-14 lg:grid-cols-2 lg:gap-16" data-id="element-297" data-mp="3te8112viq3of">
          <div data-id="element-298" data-mp="3oe2eg143v7d7">
            <h2 id="shy-title" className="text-balance font-display text-[38px] leading-[1.05] text-navy sm:text-5xl" data-id="element-299" data-mp="3oellunw4qdcz">
              Deine Schüchternheit muss deinem Gehorsam nicht im Weg stehen
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-ink-soft" data-id="element-300" data-mp="3fkyud9yyfw9l">Vielleicht dachtest du bisher, Evangelisation sei nur etwas für …</p>
            <ul className="mt-4 space-y-2.5" data-id="element-301" data-mp="35m9n0b4opu7l">
              {evangelismMyths.map(m => <li key={m} className="text-lg text-ink-mute line-through decoration-coral/60 decoration-2" data-id="element-302" data-mp="30npzi6ag0ad4">
                  {m}
                </li>)}
            </ul>
          </div>

          <div className="rounded-[28px] bg-white p-8 shadow-card ring-1 ring-cream-line sm:p-10" data-id="element-303" data-mp="de27sng5awjq">
            <p className="text-lg font-bold leading-relaxed text-navy" data-id="element-304" data-mp="3uv26rgworswo">Doch der Missionsbefehl gilt nicht nur Pastoren und Missionaren.</p>
            <p className="mt-3 text-lg leading-relaxed text-ink-soft" data-id="element-305" data-mp="3pajqqe7gwe3">Und du musst nicht warten, bis all deine Ängste verschwunden sind, um anzufangen.</p>
            <p className="mt-6 text-lg leading-relaxed text-ink-soft" data-id="element-306" data-mp="wd6gtw7osqbe">Manchmal besteht der erste Schritt einfach darin, bereit zu sein, etwas weiterzugeben:</p>
            <ul className="mt-4 space-y-1" data-id="element-307" data-mp="hfnrosr3kb3f">
              {firstSteps.map(s => <li key={s} className="flex items-center gap-3 font-display text-3xl text-navy" data-id="element-308" data-mp="mdp815x51wb7">
                  <HeartMark className="h-4 w-4 shrink-0 text-coral" data-id="element-309" data-mp="325d7p93je2xp" />
                  {s}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-16 max-w-2xl text-center" data-id="element-310" data-mp="1dms634d2bu09">
          <p className="text-lg leading-relaxed text-ink-soft" data-id="element-311" data-mp="1doblksqwa10z">
            <strong className="text-navy" data-id="element-312" data-mp="18nxpm92kihjb">{productName}</strong> gibt dir ein einfaches Werkzeug an die Hand, mit dem du diesen ersten Schritt gehen
            kannst.
          </p>
          <p className="mt-4 font-display text-[28px] leading-tight text-navy sm:text-[34px]" data-id="element-313" data-mp="ywky5ikoltdt">
            Denn vielleicht weißt du nicht immer genau, was du sagen sollst …
            <span className="block italic text-coral" data-id="element-314" data-mp="px6asrzt9yxj">Aber du kannst immer bereit sein, einen Samen zu säen.</span>
          </p>
          <CtaButton className="mt-8" data-id="element-315" data-mp="kywak2z8c852">Jetzt entdecken</CtaButton>
        </div>
      </div>
    </section>;
}